module.exports = __webpack_public_path__ + "static/media/positive-image2.f3e22dfa.png";